
export const formatTimeTo12Hour = (value) => {
  if (!value) return "";

  // Case 1: Only time (HH:mm:ss)
  if (/^\d{2}:\d{2}(:\d{2})?$/.test(value)) {
    const [h, m] = value.split(":");
    let hours = parseInt(h, 10);
    const minutes = m;

    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;

    return `${String(hours).padStart(2, "0")}:${minutes} ${ampm}`;
  }

  // Case 2: Full date string (UTC or IST)
  const date = new Date(value);
  if (isNaN(date.getTime())) return "";

  return date.toLocaleTimeString("en-IN", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
    timeZone: "Asia/Kolkata",
  }).toUpperCase();
};


export const formatExcelTime = (timeStr) => {
  if (!timeStr) return null;

  // Handle "08:29 AM" or "08:29:00 AM" format
  const ampmMatch = String(timeStr).match(/(\d{1,2}):(\d{2})(?::(\d{2}))?\s*(AM|PM)/i);
  if (ampmMatch) {
    let hours   = parseInt(ampmMatch[1], 10);
    const minutes = parseInt(ampmMatch[2], 10);
    const seconds = parseInt(ampmMatch[3] || "0", 10);
    const period  = ampmMatch[4].toUpperCase();
    if (period === "AM" && hours === 12) hours = 0;
    if (period === "PM" && hours !== 12) hours += 12;
    return (hours * 3600 + minutes * 60 + seconds) / 86400;
  }

  // Handle "09:19:31" or "09:19" 24-hour format
  const match = String(timeStr).match(/(\d{1,2}):(\d{2})(?::(\d{2}))?/);
  if (!match) return null;
  const hours   = parseInt(match[1], 10);
  const minutes = parseInt(match[2], 10);
  const seconds = parseInt(match[3] || "0", 10);
  return (hours * 3600 + minutes * 60 + seconds) / 86400;
};



export const formatDateTimeToIst = (dateString, displayTimeOnly = false) => {
  if (!dateString) return "-";

  const date = new Date(
    dateString.endsWith("Z") ? dateString : `${dateString}Z`
  );

  const timeOptions = {
    timeZone: "Asia/Kolkata",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  };

  const dateOptions = {
    timeZone: "Asia/Kolkata",
    day: "2-digit",
    month: "short",
    year: "numeric",
  };

  const formatTime = (d) =>
    d.toLocaleTimeString("en-IN", timeOptions).toUpperCase();

  if (displayTimeOnly) {
    return formatTime(date);
  }

  const formattedDate = date.toLocaleDateString("en-IN", dateOptions);
  const formattedTime = formatTime(date);

  return `${formattedDate} ${formattedTime}`;
};